import React, { useContext } from "react";
import { Modal, Header, Card } from "semantic-ui-react";
import GLGIcon from "./GLGIcon";
import { AppStoreContext } from "../stores/AppStore";
import "./ModalWhatsNext.css";
import {useTranslation} from "react-i18next";
const cardGroupStyle = { paddingBottom: "2rem" };

export default function ModalWhatsNext() {
  const appStore = useContext(AppStoreContext);
  const [t] = useTranslation();
  let content;

  content = (
    <>
      <p>
      {t("accept_modal_body")}
      </p>
      <Card.Group itemsPerRow={2} centered style={cardGroupStyle}>
        <div
          onClick={() => {
            appStore.showAcceptedModal = false;
          }}
          className="whats-next-card"
        >
          <div className="whats-next-card-main">
            <GLGIcon name="profile-1" size="huge" />
            <h3 dangerouslySetInnerHTML={{ __html: t('accept_modal_ok')}}></h3>
          </div>
        </div>
      </Card.Group>
    </>
  )


  return (
    <Modal
      open={true}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      dimmer="blurring"
      style={{ maxWidth: 650 }}
      className="whats-next-modal"
    >
      <Modal.Content>
        <div className="whats-next-success-box success red">
          <span>{t("accept_modal_success")}</span>
        </div>
        <Header as="h1">
          {t("accept_modal_header")}
        </Header>
        { content }
      </Modal.Content>
    </Modal>
  );
}
